import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { sanitizeHTML, linkifyText } from '../../../../utils/string.js';
import { callExternalLinkHandler } from '../../utils.jsx';
import Truncate from '../../truncate.jsx';

import _ from 'lodash';

class ItemContent extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.proxyExternalLinks();
  }

  componentDidUpdate() {
    this.proxyExternalLinks();
  }

  proxyExternalLinks() {
    // WYN-1359
    // Argh. Can't attach React event listeners to individual anchor tags within description/content as they are treated
    // as a single html string. Instead, attach standard click event listeners and proxy back to our external link handler
    // if required.
    if (this.props.onExternalLinkClick) {
      const links = this.contentWrapper.getElementsByTagName('a');
      [...links].map((link) => {
        link.onclick = (e) => {
          // External link handler.
          callExternalLinkHandler(this.props.onExternalLinkClick, link.href, e);
        };
      });
    }
  }

  render() {
    const wrapperClass = clsx({
      xCopyContainer: true,
      xMain:          this.props.type === 'main',
      xSecondary:     this.props.type === 'secondary',
    });

    let { heading, description, content, network, displayedUrls, caption, byline, tags } = this.props;

    const headingCx = clsx('xTitle xHeading', {
      xHeadingTruncate: this.props.truncateHeader,
    });

    heading = linkifyText(network, heading, displayedUrls, tags);
    description = linkifyText(network, description, displayedUrls, tags);
    content = linkifyText(network, content, displayedUrls, tags);
    return (
      <div className={wrapperClass} ref={(contentWrapper) => (this.contentWrapper = contentWrapper)}>
        <If condition={!!heading && !this.props.hideHeader}>
          <h1 className={headingCx} dangerouslySetInnerHTML={sanitizeHTML(heading)} />
        </If>
        <If condition={!!byline}>
          <Choose>
            <When condition={!_.isNil(this.props.bylineHeight)}>
              <Truncate
                maxHeight={this.props.bylineHeight}
                content={byline}
                render={(truncatedText, ref) => (
                  <h2 className="xTitle xByline" ref={ref}>
                    {truncatedText}
                  </h2>
                )}
              />
            </When>
            <Otherwise>
              <h2 className="xTitle xByline">{byline}</h2>
            </Otherwise>
          </Choose>
        </If>
        <If condition={!!description}>
          <p className="xCopy xContentBody" dangerouslySetInnerHTML={sanitizeHTML(description)} />
        </If>
        <If condition={!!content}>
          <Choose>
            <When condition={!_.isNil(this.props.copyBodyHeight)}>
              <Truncate
                maxHeight={this.props.copyBodyHeight}
                content={sanitizeHTML(content)}
                render={(truncatedText, ref) => (
                  <p className="xCopy xContentBody" dangerouslySetInnerHTML={truncatedText} ref={ref} />
                )}
              />
            </When>
            <Otherwise>
              <p className="xCopy xContentBody" dangerouslySetInnerHTML={sanitizeHTML(content)} />
            </Otherwise>
          </Choose>
        </If>
        <If condition={!!caption}>
          <Choose>
            <When condition={!_.isNil(this.props.copyBodyHeight)}>
              <Truncate
                maxHeight={this.props.copyBodyHeight}
                content={sanitizeHTML(caption)}
                render={(truncatedText, ref) => (
                  <p className="xCopy xCaption" dangerouslySetInnerHTML={truncatedText} ref={ref} />
                )}
              />
            </When>
            <Otherwise>
              <p className="xCopy xCaption" dangerouslySetInnerHTML={sanitizeHTML(caption)} />
            </Otherwise>
          </Choose>
        </If>
      </div>
    );
  }
}

ItemContent.propTypes = {
  type:          PropTypes.string.isRequired,
  heading:       PropTypes.string,
  byline:        PropTypes.string,
  description:   PropTypes.string,
  content:       PropTypes.string,
  caption:       PropTypes.string,
  network:       PropTypes.string,
  displayedUrls: PropTypes.arrayOf(
    PropTypes.shape({
      displayUrl: PropTypes.string,
      linkUrl:    PropTypes.string,
    })
  ),
  onExternalLinkClick: PropTypes.func,
  copyBodyHeight:      PropTypes.number, // used for mediaLayer truncation
};

export default ItemContent;
